<script>
	export let items = [];
	export let multisel = false;
	export let grouplist = [];
	export let group = null;
	export let name;
	export let icon = false;
</script>

<ul class="seg-group" class:icon>
	{#each items as item}
		<li class="seg-button">
			{#if multisel}
				<input type="checkbox" bind:group={grouplist} id="{item.val}" name="{name}" value="{item.val}">
			{:else}
				<input type="radio" bind:group={group} id="{item.val}" name="{name}" value="{item.val}">
			{/if}
			
			<label for="{item.val}">
				{#if item.img}
					<img src="{item.img}" alt="{item.val}" title="{item.label}" />
				{/if}
				<span>{item.label}</span>
			</label>
		</li>
	{/each}
</ul>

<style>
	ul.seg-group {
		list-style: none;
		margin: 0;
		margin-bottom: 2rem;
		padding: 0.25rem;
		border: 2px solid #333;
		border-radius: 0.25rem;
		display: flex;
		gap: 0.5rem;
	}
	
	.seg-button {
		flex-grow: 1;
		display: flex;
		font-weight: bold;
		border-radius: 2px;
		overflow: hidden;
	}
	
	.seg-button input {
		position: absolute;
		width: 0;
		height: 0;
		opacity: 0;
	}
	
	.seg-button label {
		width: 100%;
		height: 2rem;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		transition: all ease 0.2s;
	}
	
	.seg-button label:hover,
	.seg-button input:focus + label {
		background-color: #ddd;
	}
	
	.seg-button input:checked + label {
		background-color: #333;
		color: #fff;
	}
	
	ul.seg-group.icon .seg-button span {
		width: 0;
		height: 0;
		opacity: 0;
		overflow: hidden;
	}
	
	ul.seg-group input:checked + label img {
		filter: invert(1);
	}

</style>